const toastConfig = {
  position:     'top-right',
  autoClose:    2000,
  pauseOnHover: false,
};

module.exports = {
  toastConfig,
};
